import PropTypes from 'prop-types'
import React from 'react'

import { commaStyleString } from '../../../common/utils/formatString'

class MarketplaceStats extends React.Component {
  static propTypes = {
    stats: PropTypes.object.isRequired
  }

  render () {
    let { stats } = this.props
    return (
      <ul className='global-footer-stats__list'>
        {stats && stats.total_users.toString() &&
          <li className='global-footer-stats__list-item h-p0'>
            <span className='global-footer-stats__number'>
              {`${commaStyleString(stats.total_users)} `}
            </span>
            community members
          </li>
        }
        {stats && stats.total_items.toString() &&
          <li className='global-footer-stats__list-item h-p0'>
            <span className='global-footer-stats__number'>
              {`${commaStyleString(stats.total_items)} `}
            </span>
            items for sale
          </li>
        }
      </ul>
    )
  }
}

export default MarketplaceStats



// WEBPACK FOOTER //
// ./client/components/footer/marketplaceStats.js